import { useEffect } from 'react'

/** Inserts <link rel="preload" as="image"> as soon as the URL is known. */
export function useImagePreload(href?: string) {
  useEffect(() => {
    if (!href) return

    const link = document.createElement('link')
    link.setAttribute('rel', 'preload')
    link.setAttribute('as', 'image')
    link.setAttribute('href', href)
    document.head.appendChild(link)

    return () => {
      link.remove()
    }
  }, [href])
}
